import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  HorizontalStack,
  Icon,
  Image,
  KCol,
  KContentMenu,
  KContentMenuItem,
  KContentMenuPanel,
  KRow,
  Label,
  LayoutHeader,
  LayoutLeft,
  Menu,
  MenuItem,
  SubMenu
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { withContext } from "../../shared/hoc/with-context";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { MasterEkran_ScreenBase } from "./masterekran-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [
  { key: "522323", screenName: "HomePage", params: {}, isStartingScreen: true },
  { key: "749004", screenName: "TicketListesi", params: {}, isStartingScreen: false },
  { key: "995851", screenName: "MusteriKayit", params: {}, isStartingScreen: false },
  { key: "78879", screenName: "TicketOlusturma", params: {}, isStartingScreen: false },
  { key: "110064", screenName: "SistemLoglari", params: {}, isStartingScreen: false },
  { key: "314208", screenName: "KullaniciEkle", params: {}, isStartingScreen: false },
  { key: "756851", screenName: "KullaniciListesi", params: {}, isStartingScreen: false },
  { key: "123595", screenName: "DepartmanEkle", params: {}, isStartingScreen: false }
];

class MasterEkran_Screen extends MasterEkran_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin spinning={this.state.spinnerCount > 0}>
          <Form
            form={this.props.form}
            name="basic"
            initialValues={{
              ...this.props.initialValues,
              masterekran_50739_value: "e19f1ffe-1696-467b-2c72-08ddba70b366",
              masterekran_953212_value: { collapsed: false, selectedKey: "" }
            }}
            onValuesChange={(changedValues, allValues) => {
              this.clearFieldValidation(changedValues);
            }}
          >
            <div style={{} as any}>
              <LayoutHeader
                id="Minus10"
                id="masterekran_layout_header"
                layoutPosition={1}
                style={
                  {
                    borderStyle: "solid",
                    borderTopWidth: 0,
                    borderRightWidth: 0,
                    borderBottomWidth: 0,
                    borderLeftWidth: 0,
                    backgroundImage: "linear-gradient(90deg, rgba(61, 79, 95, 1) 0%, rgba(61, 79, 95, 0.73) 100%)",
                    paddingTop: 0,
                    paddingRight: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    height: "80px",
                    fontFamily: "Poppins",
                    fontWeight: 400,
                    fontSize: "15px",
                    color: "rgba(68, 68, 68, 1)"
                  } as any
                }
              >
                <KRow
                  id="509636"
                  align="top"
                  justify="start"
                  horizontalGutter={0}
                  verticalGutter={0}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      paddingTop: 8,
                      paddingRight: 8,
                      paddingBottom: 8,
                      paddingLeft: 8,
                      alignItems: "flex-start",
                      textAlign: "-webkit-left",
                      fontFamily: "Poppins",
                      fontWeight: 400,
                      fontSize: "15px",
                      color: "rgba(68, 68, 68, 1)"
                    } as any
                  }
                >
                  <KCol
                    id="282971"
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        paddingTop: 0,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "center",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)"
                      } as any
                    }
                  >
                    <Form.Item className="kFormItem" name="masterekran_50739_value">
                      <Image
                        id="50739"
                        onClick={(e?: any) => {
                          if (e && e.stopPropagation) e.stopPropagation();
                          this.MasterEkranComponent_50739_onClick();
                        }}
                        showCursorPointer
                        zoomOnClick={false}
                        imageFit="fit"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            width: "180px",
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(255, 255, 255, 1)"
                          } as any
                        }
                      ></Image>
                    </Form.Item>
                  </KCol>
                  <KCol
                    id="323064"
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-right",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: "15px",
                        color: "rgba(68, 68, 68, 1)"
                      } as any
                    }
                  >
                    <KContentMenu
                      id="484892"
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 0,
                          paddingRight: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: "15px",
                          color: "rgba(68, 68, 68, 1)"
                        } as any
                      }
                    >
                      <KContentMenuPanel
                        id="843029"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)"
                          } as any
                        }
                      >
                        <HorizontalStack
                          id="843331"
                          direction="horizontal"
                          size={25}
                          overflowX="hidden"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: "15px",
                              color: "rgba(68, 68, 68, 1)"
                            } as any
                          }
                        >
                          <Icon
                            id="738321"
                            iconName="person"
                            style={
                              {
                                borderTopLeftRadius: 8,
                                borderTopRightRadius: 8,
                                borderBottomRightRadius: 8,
                                borderBottomLeftRadius: 8,
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                backgroundColor: "rgba(61, 79, 95, 0.34)",
                                paddingTop: 5,
                                paddingRight: 5,
                                paddingBottom: 5,
                                paddingLeft: 5,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "35px",
                                color: "rgba(255, 255, 255, 1)",
                                letterSpacing: "1px"
                              } as any
                            }
                          ></Icon>
                          <Label
                            id="618412"
                            value={ReactSystemFunctions.getMyUsername()}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                width: "100px",
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "15px",
                                color: "rgba(255, 255, 255, 1)"
                              } as any
                            }
                          ></Label>
                          <Icon
                            id="683415"
                            iconName="keyboard_arrow_down"
                            style={
                              {
                                borderTopLeftRadius: 8,
                                borderTopRightRadius: 8,
                                borderBottomRightRadius: 8,
                                borderBottomLeftRadius: 8,
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 10,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "24px",
                                color: "rgba(255, 255, 255, 1)",
                                letterSpacing: "1px"
                              } as any
                            }
                          ></Icon>
                        </HorizontalStack>
                      </KContentMenuPanel>
                      <KContentMenuItem
                        id="166416"
                        onClick={(e?: any) => {
                          if (e && e.stopPropagation) e.stopPropagation();
                          this.MasterEkranComponent_166416_onClick();
                        }}
                        showCursorPointer
                        label={ReactSystemFunctions.translate(this.ml, 166416, "label", this.defaultML)}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)"
                          } as any
                        }
                      ></KContentMenuItem>
                      <KContentMenuItem
                        id="759500"
                        onClick={(e?: any) => {
                          if (e && e.stopPropagation) e.stopPropagation();
                          this.MasterEkranComponent_759500_onClick();
                        }}
                        showCursorPointer
                        label={ReactSystemFunctions.translate(this.ml, 759500, "label", this.defaultML)}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: "15px",
                            color: "rgba(225, 60, 57, 1)"
                          } as any
                        }
                      ></KContentMenuItem>
                    </KContentMenu>
                  </KCol>
                </KRow>
              </LayoutHeader>
              <div style={{ display: "flex" } as any}>
                <LayoutLeft
                  id="Minus12"
                  id="masterekran_layout_left"
                  layoutPosition={1}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(255, 255, 255, 1)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                      paddingTop: 0,
                      paddingRight: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      width: "100px",
                      fontFamily: "Poppins",
                      fontWeight: 400,
                      fontSize: "15px",
                      color: "rgba(68, 68, 68, 1)"
                    } as any
                  }
                >
                  <Form.Item className="kFormItem" name="masterekran_953212_value" noStyle>
                    <Menu
                      id="953212"
                      menuMap={menuMap}
                      options={this.state.dataSource_953212}
                      mode="vertical"
                      theme="light"
                      primaryColor="rgba(61, 79, 95, 1)"
                      collapsible={true}
                      collapsedButtonColor="rgba(61, 79, 95, 1)"
                      hamburgerControl={false}
                      closeSiblingSubmenusOnOpen={false}
                      style={{ width: "240px" } as any}
                    >
                      <MenuItem
                        id="522323"
                        onClick={(e?: any) => {
                          if (e && e.stopPropagation) e.stopPropagation();
                          this.MasterEkranComponent_522323_onClick();
                        }}
                        showCursorPointer
                        key={522323}
                        label={ReactSystemFunctions.translate(this.ml, 522323, "label", this.defaultML)}
                        icon="home"
                        key={522323}
                        style={
                          {
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "10pt",
                            color: "rgba(61, 79, 95, 1)"
                          } as any
                        }
                      ></MenuItem>
                      <MenuItem
                        id="749004"
                        onClick={(e?: any) => {
                          if (e && e.stopPropagation) e.stopPropagation();
                          this.MasterEkranComponent_749004_onClick();
                        }}
                        showCursorPointer
                        key={749004}
                        label={ReactSystemFunctions.translate(this.ml, 749004, "label", this.defaultML)}
                        icon="confirmation_number"
                        key={749004}
                        style={{ fontFamily: "Poppins", fontSize: "10pt", color: "rgba(61, 79, 95, 1)" } as any}
                      ></MenuItem>
                      <SubMenu
                        id="4777"
                        label={ReactSystemFunctions.translate(this.ml, 4777, "label", this.defaultML)}
                        icon="people_alt"
                        key={4777}
                        style={{ fontFamily: "Poppins", fontSize: "10pt", color: "rgba(61, 79, 95, 1)" } as any}
                      >
                        <MenuItem
                          id="995851"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.MasterEkranComponent_995851_onClick();
                          }}
                          showCursorPointer
                          key={995851}
                          label={ReactSystemFunctions.translate(this.ml, 995851, "label", this.defaultML)}
                          key={995851}
                          style={{ fontFamily: "Poppins", fontSize: "10pt", color: "rgba(61, 79, 95, 1)" } as any}
                        ></MenuItem>
                        <MenuItem
                          id="78879"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.MasterEkranComponent_78879_onClick();
                          }}
                          showCursorPointer
                          key={78879}
                          label={ReactSystemFunctions.translate(this.ml, 78879, "label", this.defaultML)}
                          key={78879}
                          style={{ fontFamily: "Poppins", fontSize: "10pt", color: "rgba(61, 79, 95, 1)" } as any}
                        ></MenuItem>
                      </SubMenu>
                      <SubMenu
                        id="601782"
                        label={ReactSystemFunctions.translate(this.ml, 601782, "label", this.defaultML)}
                        icon="person"
                        key={601782}
                        style={{ fontFamily: "Poppins", fontSize: "10pt", color: "rgba(61, 79, 95, 1)" } as any}
                      >
                        <MenuItem
                          id="110064"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.MasterEkranComponent_110064_onClick();
                          }}
                          showCursorPointer
                          key={110064}
                          label={ReactSystemFunctions.translate(this.ml, 110064, "label", this.defaultML)}
                          key={110064}
                          style={{ fontFamily: "Poppins", fontSize: "10pt", color: "rgba(61, 79, 95, 1)" } as any}
                        ></MenuItem>
                        <MenuItem
                          id="314208"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.MasterEkranComponent_314208_onClick();
                          }}
                          showCursorPointer
                          visibility={this.state.isCompmasterekran_314208AuthorizationVisible}
                          visibilityByAuthorization={this.state.isCompmasterekran_314208AuthorizationVisible}
                          key={314208}
                          label={ReactSystemFunctions.translate(this.ml, 314208, "label", this.defaultML)}
                          key={314208}
                          style={{ fontFamily: "Poppins", fontSize: "10pt", color: "rgba(61, 79, 95, 1)" } as any}
                        ></MenuItem>
                        <MenuItem
                          id="756851"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.MasterEkranComponent_756851_onClick();
                          }}
                          showCursorPointer
                          key={756851}
                          label={ReactSystemFunctions.translate(this.ml, 756851, "label", this.defaultML)}
                          key={756851}
                          style={{ fontFamily: "Poppins", fontSize: "10pt", color: "rgba(61, 79, 95, 1)" } as any}
                        ></MenuItem>
                        <MenuItem
                          id="123595"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.MasterEkranComponent_123595_onClick();
                          }}
                          showCursorPointer
                          visibility={this.state.isCompmasterekran_123595AuthorizationVisible}
                          visibilityByAuthorization={this.state.isCompmasterekran_123595AuthorizationVisible}
                          key={123595}
                          label={ReactSystemFunctions.translate(this.ml, 123595, "label", this.defaultML)}
                          key={123595}
                          style={{ fontFamily: "Poppins", fontSize: "10pt", color: "rgba(61, 79, 95, 1)" } as any}
                        ></MenuItem>
                      </SubMenu>
                    </Menu>
                  </Form.Item>
                </LayoutLeft>
                <div id="masterRootDI_wrapper" style={{ flex: "auto", background: "#f0f2f5" } as any}>
                  <div style={{ display: "flex" } as any}>
                    <div
                      id="masterRootDI"
                      style={
                        {
                          flex: "auto",
                          overflow: "hidden auto",
                          maxWidth: "100vw",
                          width: 0,
                          position: "relative",
                          height: "calc(100vh - 86px)"
                        } as any
                      }
                    >
                      <>{this.props.children}</>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible: state.importMappedExcelModalReducer.visible
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) => dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) => dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) => dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) => dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (dsId, tableName, primaryKey, columnMapping, parameters) =>
    dispatch(showImportMappedExcelModal(dsId, tableName, primaryKey, columnMapping, parameters)),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal())
});
const tmp = withGoogleLogin(
  withContext(withScreenInput(withHistory(connect(mapStateToProps, mapDispatchToProps)(MasterEkran_Screen))))
);
export { tmp as MasterEkran_Screen };
//export default tmp;
//export { tmp as MasterEkran_Screen };
